<template>
  <div style="height: 100%" class="bg">
    <div class="xqleft">
      <div style="display: flex; margin-top: 40px;" class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">电池soc</h1>
      </div>
      <div class="soc">80%</div>
      <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
    </div>
    <div class="xqleft">
      <div style="display: flex; margin-top: 10px;" class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">近24小时总负载电流</h1>
      </div>
      <div style="height:180px"><v-chart class="chart" :option="options" :autoresize="true" /></div>

    </div>
    <div class="xqleft">
      <div style="display: flex; margin-top: 15px;" class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">故障统计</h1>
      </div>
      <div>
        <GaoJing :chatdata="chatdata" />
      </div>
      <div class="llist">
        <ul>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ gaojing.warning_num_total }}<span class="danwei">次</span></h2>
            <h1 class="mingcheng">告警次数</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ gaojing.warning_process_percent }}<span class="danwei">%</span></h2>
            <h1 class="mingcheng">处理情况</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ gaojing.process_avg_time }}<span class="danwei">分钟</span></h2>
            <h1 class="mingcheng">平均处理时间</h1>

          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/api/http";

import { defineComponent, ref, onMounted, watch } from "vue";
import * as echarts from 'echarts';
import GaoJing from "./GaoJing.vue";
import "echarts-liquidfill";
import { useStore } from "vuex";
export default defineComponent({
  components: {

    GaoJing,
  },
  props: { gaojing: Object, },
  setup(props) {

    let dataC1 = [20, 30, 60, 40, 50, 30];
    let xData = ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00"];


    const options = ref({
      grid: {
        left: "16%",
        right: "10%",
        top: "10%",
        bottom: "15%",
      },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#57617B",
          },
        },
      },
      xAxis: {
        type: "category",

        boundaryGap: false, //顶头显示
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
        axisTick: {
          show: false,
          // alignWithLabel: true,
          lineStyle: {
            color: "#3585d5",
          },
        },
        axisLabel: {
          fontSize: 12,
          color: "#b2bacc",
        },
        data: xData,
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dotted",
            color: "#3585d5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 12,
          formatter: "{value}A",
          color: "#b2bacc",
        },
        boundaryGap: false,
      },
      series: [
        {
          name: "电流",
          type: "line",
          stack: "总量",
          smooth: true,
          symbol: "none",
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: "#15faff",
              lineStyle: {
                color: "#1c6bca",
                width: 2,
              },
              areaStyle: {
                //color: '#94C9EC'
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0.4,
                    color: "rgba(10, 40, 80,0.1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(10, 40, 80,0.9)",
                  },
                ]),
              },
            },
          },

          data: dataC1,
        },
      ],
    });

    const store = useStore()
    let stationid = store.getters['User/stationid']
    const getData = () => {
      http.get("/base_station/" + stationid).then((res) => {
        //let soc = res.data.base_info.soc
        let soc = 0.8

        console.log(res, soc)

      });
    };



    let chatdata = ref([])
    watch(props, () => {

      chatdata.value = props.gaojing.warning_list



    }, {
      deep: true
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法

      getData();
    });

    return {
      options, chatdata, getData
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xqleft {


  color: #fff;
  display: flex;
  flex-direction: column;
}

.soc {
  background: url("@/assets/dc5.png") no-repeat;
  width: 119px;
  height: 153px;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
  padding-top: 90px;
}

.biaoti {
  background: url("@/assets/biaoti.png") no-repeat;
  margin: 0 20px;
  padding-left: 30px;
}

.bg {
  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
}

.quxian {
  font-size: 18px;
  color: #fdff76;
}

.llist {
  padding: 10px 20px 0;
  overflow: hidden;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 50%;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.mingcheng {
  color: #ccccdc;
  font-size: 13px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 18px;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.danwei {
  color: #fff;
  font-size: 12px;
  padding-left: 5px;
}
</style>
